module.exports = __webpack_public_path__ + "商思林-72e18cd1.png";